<template>
  <div class="device-page">
    <v-card flat>
      <v-card-title>
        <span class="text-h5 IranSans">{{
          deviceId ? "ویرایش دستگاه" : "دستگاه جدید"
        }}</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <!-- اطلاعات پایه دستگاه -->
            <v-row>
              <v-col cols="4" sm="12" md="4">
                <v-text-field
                  outlined
                  clearable
                  v-model="device.name"
                  label="نام *"
                  placeholder=" "
                  autocomplete="false"
                  :rules="nameRules"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="4" sm="12" md="4">
                <v-text-field
                  outlined
                  clearable
                  v-model="device.hardwareCode"
                  label="نام سخت افزاری *"
                  placeholder=" "
                  autocomplete="false"
                  :rules="hardwareCodeRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="12" md="4">
                <v-text-field
                  outlined
                  clearable
                  v-model="device.advertisingCode"
                  label="نام دستگاه تبلیغات *"
                  placeholder=" "
                  autocomplete="false"
                  :rules="advertisingCodeRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="12" md="4">
                <v-text-field
                  outlined
                  clearable
                  v-model="device.mediaboxUrl"
                  label="آدرس Url مدیاباکس"
                  placeholder=" "
                  autocomplete="false"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="12" md="4">
                <v-text-field
                  outlined
                  clearable
                  v-model="device.mediaboxScreenCode"
                  label="کد نمایشگر مدیاباکس"
                  placeholder=" "
                  autocomplete="false"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="device.onlineAdActive"
                  :label="
                    `پخش تبلیغات آنلاین: ${
                      device.onlineAdActive ? 'فعال' : 'غیرفعال'
                    }`
                  "
                ></v-switch>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                  outlined
                  type="number"
                  clearable
                  v-model="device.lockerCount"
                  label="تعداد لاکرها *"
                  placeholder=" "
                  autocomplete="false"
                  :rules="lockerCountRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col v-if="deviceTypePerm()" cols="12" sm="12" md="3">
                <v-autocomplete
                  v-model="device.deviceTypeId"
                  :items="deviceTypes"
                  item-text="name"
                  item-value="id"
                  label="نوع دستگاه"
                  clearable
                  solo
                  hide-details="auto"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <!-- ویژگی‌های فیزیکی دستگاه -->
            <v-row>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="device.hasLightBox"
                  :label="`لایت باکس: ${device.hasLightBox ? 'دارد' : 'ندارد'}`"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="device.hasScreen"
                  :label="`اسکرین: ${device.hasScreen ? 'دارد' : 'ندارد'}`"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="device.hasCaseDoor"
                  :label="`درب کیس: ${device.hasCaseDoor ? 'دارد' : 'ندارد'}`"
                ></v-switch>
              </v-col>
            </v-row>

            <!-- نمایش شرطی فیلدهای آستانه -->
            <v-row v-if="device.hasLightBox || device.hasScreen">
              <v-col cols="12" sm="6" md="4" v-if="device.hasLightBox">
                <v-text-field
                  outlined
                  type="number"
                  clearable
                  v-model="device.lightBoxStatusThreshold"
                  label="آستانه لایت باکس"
                  placeholder=" "
                  :rules="deltaRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="device.hasScreen">
                <v-text-field
                  outlined
                  type="number"
                  clearable
                  v-model="device.screenThreshold"
                  label="آستانه صفحه نمایش"
                  placeholder=" "
                  :rules="deltaRules"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="device.hasLoadCell"
                  :label="`سنسور وزن: ${device.hasLoadCell ? 'دارد' : 'ندارد'}`"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="device.hasIR"
                  :label="
                    `سنسور مادون قرمز: ${device.hasIR ? 'دارد' : 'ندارد'}`
                  "
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="device.hasTelephone"
                  :label="
                    `ماژول تلفن: ${device.hasTelephone ? 'دارد' : 'ندارد'}`
                  "
                ></v-switch>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="4" v-if="device.hasLoadCell">
                <v-switch
                  v-model="device.loadCellIsActive"
                  :label="
                    `سنسور وزن: ${device.loadCellIsActive ? 'فعال' : 'غیرفعال'}`
                  "
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="4" v-if="device.hasIR">
                <v-switch
                  v-model="device.irIsActive"
                  :label="
                    `سنسور مادون قرمز: ${
                      device.irIsActive ? 'فعال' : 'غیرفعال'
                    }`
                  "
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="4" v-if="device.hasTelephone">
                <v-switch
                  v-model="device.telephoneActive"
                  :label="
                    `ماژول تلفن: ${device.telephoneActive ? 'فعال' : 'غیرفعال'}`
                  "
                ></v-switch>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="3">
                <v-switch
                  v-model="device.shouldBeMonitored"
                  :label="
                    `پایش سلامت: ${
                      device.shouldBeMonitored ? 'پایش شود' : 'پایش نشود'
                    }`
                  "
                ></v-switch>
              </v-col>
            </v-row>

            <!-- پرچم کد اپراتور -->
            <v-row>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="device.operatorCodeEnabled"
                  :label="
                    `کد اپراتور: ${
                      device.operatorCodeEnabled ? 'فعال' : 'غیرفعال'
                    }`
                  "
                ></v-switch>
              </v-col>
            </v-row>

            <!-- تنظیمات بازی‌ها -->
            <v-divider class="my-4"></v-divider>
            <h2 class="text-h6 IranSans mb-3">تنظیمات بازی</h2>
            <v-row>
              <v-col cols="12">
                <v-switch
                  v-model="deviceConfiguration.gameEnabled"
                  label="فعال بودن بازی‌ها"
                  color="primary"
                  :class="deviceConfiguration.gameEnabled ? 'mb-4' : ''"
                ></v-switch>
              </v-col>
            </v-row>
            <v-radio-group
              v-model="selectedGameIndex"
              hide-details
              @change="onGameSelectionChange"
              v-if="deviceConfiguration.gameEnabled"
            >
              <v-row v-for="(game, index) in gameOptions" :key="index">
                <v-col cols="12">
                  <v-card
                    outlined
                    :color="game.isActive ? 'primary lighten-5' : ''"
                  >
                    <v-card-title class="py-2">
                      <v-row no-gutters align="center">
                        <v-col cols="12" md="3">
                          <v-radio
                            class="mb-2"
                            :value="index"
                            :label="game.name"
                          >
                            <template v-slot:label>
                              <span class="pl-2">{{ game.name }}</span>
                              <v-chip
                                :color="game.isOnlineGame ? 'info' : 'success'"
                                small
                                dark
                              >
                                {{ game.isOnlineGame ? "آنلاین" : "آفلاین" }}
                              </v-chip>
                              <v-chip
                                v-if="game.isActive"
                                color="success"
                                class="mr-2"
                                small
                                dark
                              >
                                فعال
                              </v-chip>
                            </template>
                          </v-radio>
                        </v-col>
                        <v-col
                          cols="12"
                          md="9"
                          v-if="game.isOnlineGame && game.isActive"
                        >
                          <v-text-field
                            v-model="game.url"
                            label="آدرس URL بازی آنلاین"
                            placeholder="https://example.com/game"
                            dense
                            outlined
                            hide-details
                            :disabled="!game.isActive"
                            :rules="
                              game.isActive && game.isOnlineGame ? urlRules : []
                            "
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </v-radio-group>
            <v-row v-else>
              <v-col cols="12">
                <v-alert type="info" dense text>
                  بازی‌ها غیرفعال هستند. برای فعال کردن، سوئیچ بالا را بزنید.
                </v-alert>
              </v-col>
            </v-row>

            <!-- سایر تنظیمات -->
            <v-divider class="my-4"></v-divider>
            <h2 class="text-h6 IranSans mb-3">تنظیمات پیشرفته</h2>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-switch
                  v-model="deviceConfiguration.interactiveMessageEnabled"
                  label="پیام تعاملی (Interactive Message)"
                  dense
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-switch
                  v-model="deviceConfiguration.chargeContinueEnabled"
                  label="ادامه شارژ (Charge Continue)"
                  dense
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-switch
                  v-model="deviceConfiguration.safeModeEnabled"
                  label="حالت ایمن (Safe Mode)"
                  dense
                  color="orange"
                ></v-switch>
              </v-col>
            </v-row>

            <!-- تنظیمات زبان -->
            <v-divider class="my-4"></v-divider>
            <h2 class="text-h6 IranSans mb-3">تنظیمات زبان</h2>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-select
                  v-model="deviceConfiguration.supportedLanguages"
                  :items="languageOptions"
                  item-text="name"
                  item-value="code"
                  label="زبان‌های پشتیبانی شده"
                  outlined
                  dense
                  multiple
                  chips
                  clearable
                  required
                  :rules="languageRules"
                >
                  <template
                    v-slot:selection="{ attrs, item, select, selected }"
                  >
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click="select"
                      @click:close="removeLanguage(item.code)"
                    >
                      {{ item.name }}
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-select
                  v-model="deviceConfiguration.defaultLanguageCode"
                  :items="getLanguageOptions()"
                  item-text="name"
                  item-value="code"
                  label="زبان پیش‌فرض"
                  outlined
                  dense
                  required
                  :rules="defaultLanguageRules"
                  :disabled="!deviceConfiguration.supportedLanguages.length"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        ابتدا زبان‌های پشتیبانی شده را انتخاب کنید
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <!-- شماره پشتیبانی -->
            <v-divider class="my-4"></v-divider>
            <h2 class="text-h6 IranSans mb-3">پشتیبانی</h2>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  v-model="deviceConfiguration.supportPhoneNumber"
                  label="شماره پشتیبانی"
                  outlined
                  dense
                  placeholder="09123456789"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- ====================== تصاویر شرایط استفاده ====================== -->
            <v-divider class="my-4"></v-divider>
            <h2 class="text-h6 IranSans mb-3">تصاویر شرایط استفاده (Terms)</h2>
            <v-row>
              <v-col cols="12">
                <v-switch
                  v-model="device.termOfUseSync"
                  :label="
                    `عکس‌های شرایط با دستگاه: ${
                      device.termOfUseSync ? 'هماهنگ شود' : 'هماهنگ نشود'
                    }`
                  "
                ></v-switch>
              </v-col>
              <v-col cols="12">
                <v-alert
                  dense
                  text
                  type="info"
                  icon="mdi-information-outline"
                  class="mb-3"
                >
                  <div class="text-caption">
                    <strong>ابعاد استاندارد: (پیکسل)</strong><br />
                    <span>استار: ۳۰۴ × ۴۲۳ پیکسل</span><br />
                    <span>کیوب و پرایم و سیف باکس و رض: ۵۹۸ × ۸۰۷ پیکسل</span
                    ><br />
                    <span>گلکسی و لومینو: ۵۳۲ × ۸۴۳ پیکسل</span>
                  </div>
                </v-alert>
              </v-col>
            </v-row>

            <!-- لیست تصاویر شرایط استفاده -->
            <v-row v-if="termsImages.length">
              <v-col
                v-for="(img, idx) in termsImages"
                :key="'terms-' + idx"
                cols="6"
                sm="3"
                md="2"
              >
                <v-card hover>
                  <div style="position: relative;">
                    <v-img
                      :src="img.previewUrl"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <div
                        style="position: absolute; top: 0; right: 0; z-index: 1;"
                      >
                        <v-btn
                          v-if="img.previewUrl"
                          icon
                          color="blue"
                          class="ma-1"
                          @click="ViewImage(img.previewUrl)"
                        >
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          color="blue"
                          class="ma-1"
                          @click="editImage('TermsAndConditions', idx)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          color="red"
                          class="ma-1"
                          @click="removeTermsImage(idx)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </v-img>
                    <v-chip
                      x-small
                      :color="img.isExisting ? 'green' : 'orange'"
                      dark
                      class="ma-1"
                      style="position: absolute; bottom: 5px; left: 5px; z-index: 1;"
                    >
                      صفحه {{ img.pageNumber }}
                      {{ img.isExisting ? "(موجود)" : "(جدید)" }}
                    </v-chip>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12">
                <v-alert dense text type="info">
                  هنوز تصویری برای شرایط استفاده بارگذاری نشده است.
                </v-alert>
              </v-col>
            </v-row>

            <v-btn
              color="primary"
              outlined
              @click="openAddImageDialog('TermsAndConditions')"
              class="mt-3 mb-6"
            >
              <v-icon left>mdi-plus</v-icon>
              افزودن عکس شرایط استفاده
            </v-btn>

            <!-- ====================== تصاویر جایگزین UI ====================== -->
            <v-divider class="my-4"></v-divider>
            <h2 class="text-h6 IranSans mb-3">
              تصاویر جایگزین UI (تعویض آنلاین)
            </h2>
            <v-row>
              <v-col cols="12">
                <v-switch
                  v-model="device.uiReplacementSync"
                  :label="
                    `عکس‌های UI با دستگاه: ${
                      device.uiReplacementSync ? 'هماهنگ شود' : 'هماهنگ نشود'
                    }`
                  "
                ></v-switch>
              </v-col>
              <v-col cols="12">
                <v-alert
                  dense
                  text
                  type="info"
                  icon="mdi-information-outline"
                  class="mb-3"
                >
                  <div class="text-caption">
                    <strong>ابعاد استاندارد: (پیکسل)</strong><br />
                    <span>استار: ۷۷۰ × ۷۲۰ پیکسل</span><br />
                    <span>گلکسی و لومینو: ۱۰۸۰ × ۵۸۰ پیکسل</span>
                  </div>
                </v-alert>
              </v-col>
            </v-row>

            <!-- لیست تصاویر جایگزین UI -->
            <v-row v-if="uiReplacementImages.length">
              <v-col
                v-for="(img, idx) in uiReplacementImages"
                :key="'ui-' + idx"
                cols="6"
                sm="3"
                md="2"
              >
                <v-card hover>
                  <div style="position: relative;">
                    <v-img
                      :src="img.previewUrl"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <div
                        style="position: absolute; top: 0; right: 0; z-index: 1;"
                      >
                        <v-btn
                          v-if="img.previewUrl"
                          icon
                          color="blue"
                          class="ma-1"
                          @click="ViewImage(img.previewUrl)"
                        >
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          color="blue"
                          class="ma-1"
                          @click="editImage('UIReplacement', idx)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          color="red"
                          class="ma-1"
                          @click="removeUiReplacementImage(idx)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </v-img>
                    <v-chip
                      x-small
                      :color="img.isExisting ? 'green' : 'orange'"
                      dark
                      class="ma-1"
                      style="position: absolute; bottom: 5px; left: 5px; z-index: 1;"
                    >
                      صفحه {{ img.pageNumber }}
                      {{ img.isExisting ? "(موجود)" : "(جدید)" }}
                    </v-chip>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12">
                <v-alert dense text type="info">
                  هنوز تصویری برای جایگزینی UI بارگذاری نشده است.
                </v-alert>
              </v-col>
            </v-row>

            <v-btn
              color="primary"
              outlined
              @click="openAddImageDialog('UIReplacement')"
              class="mt-3 mb-6"
            >
              <v-icon left>mdi-plus</v-icon>
              افزودن عکس جایگزین UI
            </v-btn>

            <!-- ====================== فایل‌های پین (جدید) ====================== -->
            <v-divider class="my-4"></v-divider>
            <h2 class="text-h6 IranSans mb-3">فایل‌های پین</h2>

            <!-- پنل پین -->
            <v-row align="center" class="mb-2">
              <v-col cols="12">
                <v-switch
                  v-model="device.pinSync"
                  :label="
                    `پین ها با دستگاه: ${
                      device.pinSync ? 'هماهنگ شود' : 'هماهنگ نشود'
                    }`
                  "
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <span class="subtitle-2">پنل پین:</span>
              </v-col>
              <v-col cols="12" sm="6" class="text-right">
                <template v-if="panelPinFile">
                  <v-chip small color="primary" text-color="white" class="ml-2">
                    <v-icon left small>mdi-file-code</v-icon>
                    {{ panelPinFile.originalFileName }}
                  </v-chip>
                  <v-chip
                    x-small
                    :color="panelPinFile.isExisting ? 'green' : 'orange'"
                    dark
                    class="ml-1"
                  >
                    {{ panelPinFile.isExisting ? "موجود" : "جدید" }}
                  </v-chip>
                  <v-btn
                    v-if="panelPinFile.previewUrl"
                    icon
                    small
                    color="green"
                    @click="downloadPinFile('PanelPin')"
                    title="دانلود فایل"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    small
                    color="red"
                    @click="removePinFile('PanelPin')"
                    title="حذف فایل"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn
                    outlined
                    small
                    color="primary"
                    class="ml-2"
                    @click="openPinFileDialog('PanelPin')"
                  >
                    <v-icon left small>mdi-pencil</v-icon>
                    ویرایش
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn
                    outlined
                    small
                    color="primary"
                    @click="openPinFileDialog('PanelPin')"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    بارگذاری فایل
                  </v-btn>
                </template>
              </v-col>
            </v-row>

            <!-- ادمین پین -->
            <v-row align="center" class="mb-2">
              <v-col cols="12" sm="6">
                <span class="subtitle-2">ادمین پین:</span>
              </v-col>
              <v-col cols="12" sm="6" class="text-right">
                <template v-if="adminPinFile">
                  <v-chip small color="primary" text-color="white" class="ml-2">
                    <v-icon left small>mdi-file-code</v-icon>
                    {{ adminPinFile.originalFileName }}
                  </v-chip>
                  <v-chip
                    x-small
                    :color="adminPinFile.isExisting ? 'green' : 'orange'"
                    dark
                    class="ml-1"
                  >
                    {{ adminPinFile.isExisting ? "موجود" : "جدید" }}
                  </v-chip>
                  <v-btn
                    v-if="adminPinFile.previewUrl"
                    icon
                    small
                    color="green"
                    @click="downloadPinFile('AdminPin')"
                    title="دانلود فایل"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    small
                    color="red"
                    @click="removePinFile('AdminPin')"
                    title="حذف فایل"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn
                    outlined
                    small
                    color="primary"
                    class="ml-2"
                    @click="openPinFileDialog('AdminPin')"
                  >
                    <v-icon left small>mdi-pencil</v-icon>
                    ویرایش
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn
                    outlined
                    small
                    color="primary"
                    @click="openPinFileDialog('AdminPin')"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    بارگذاری فایل
                  </v-btn>
                </template>
              </v-col>
            </v-row>

            <!-- مستر پین -->
            <v-row align="center" class="mb-2">
              <v-col cols="12" sm="6">
                <span class="subtitle-2">مستر پین:</span>
              </v-col>
              <v-col cols="12" sm="6" class="text-right">
                <template v-if="masterPinFile">
                  <v-chip small color="primary" text-color="white" class="ml-2">
                    <v-icon left small>mdi-file-code</v-icon>
                    {{ masterPinFile.originalFileName }}
                  </v-chip>
                  <v-chip
                    x-small
                    :color="masterPinFile.isExisting ? 'green' : 'orange'"
                    dark
                    class="ml-1"
                  >
                    {{ masterPinFile.isExisting ? "موجود" : "جدید" }}
                  </v-chip>
                  <v-btn
                    v-if="masterPinFile.previewUrl"
                    icon
                    small
                    color="green"
                    @click="downloadPinFile('MasterPin')"
                    title="دانلود فایل"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    small
                    color="red"
                    @click="removePinFile('MasterPin')"
                    title="حذف فایل"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn
                    outlined
                    small
                    color="primary"
                    class="ml-2"
                    @click="openPinFileDialog('MasterPin')"
                  >
                    <v-icon left small>mdi-pencil</v-icon>
                    ویرایش
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn
                    outlined
                    small
                    color="primary"
                    @click="openPinFileDialog('MasterPin')"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    بارگذاری فایل
                  </v-btn>
                </template>
              </v-col>
            </v-row>

            <!-- کلینر پین -->
            <v-row align="center" class="mb-2">
              <v-col cols="12" sm="6">
                <span class="subtitle-2">کلینر پین:</span>
              </v-col>
              <v-col cols="12" sm="6" class="text-right">
                <template v-if="cleanerPinFile">
                  <v-chip small color="primary" text-color="white" class="ml-2">
                    <v-icon left small>mdi-file-code</v-icon>
                    {{ cleanerPinFile.originalFileName }}
                  </v-chip>
                  <v-chip
                    x-small
                    :color="cleanerPinFile.isExisting ? 'green' : 'orange'"
                    dark
                    class="ml-1"
                  >
                    {{ cleanerPinFile.isExisting ? "موجود" : "جدید" }}
                  </v-chip>
                  <v-btn
                    v-if="cleanerPinFile.previewUrl"
                    icon
                    small
                    color="green"
                    @click="downloadPinFile('CleanerPin')"
                    title="دانلود فایل"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    small
                    color="red"
                    @click="removePinFile('CleanerPin')"
                    title="حذف فایل"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn
                    outlined
                    small
                    color="primary"
                    class="ml-2"
                    @click="openPinFileDialog('CleanerPin')"
                  >
                    <v-icon left small>mdi-pencil</v-icon>
                    ویرایش
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn
                    outlined
                    small
                    color="primary"
                    @click="openPinFileDialog('CleanerPin')"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    بارگذاری فایل
                  </v-btn>
                </template>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <!-- ====================== Dialog افزودن/ویرایش عکس (کامل) ====================== -->
      <v-dialog
        v-if="addImageDialog"
        v-model="addImageDialog"
        max-width="450px"
        persistent
      >
        <v-card>
          <v-card-title class="text-h6 IranSans">
            {{ editingImage ? "ویرایش عکس" : "افزودن عکس جدید" }}
            <span v-if="currentImageType === 'TermsAndConditions'">
              (شرایط استفاده)
            </span>
            <span v-else>
              (جایگزین UI)
            </span>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model.number="newImagePageNumber"
                  label="شماره صفحه *"
                  type="number"
                  outlined
                  :disabled="currentImageType === 'TermsAndConditions'"
                  hint="شماره صفحه به صورت خودکار تعیین می‌شود"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  v-model="newImageFile"
                  label="انتخاب عکس *"
                  accept="image/*"
                  outlined
                  :rules="imageFileRules"
                  hint="فرمت‌های مجاز: jpg, jpeg, png"
                  persistent-hint
                  @change="onNewImageSelected"
                ></v-file-input>
              </v-col>

              <!-- پیش‌نمایش عکس انتخاب شده -->
              <v-col cols="12" v-if="newImagePreview">
                <v-img
                  :src="newImagePreview"
                  max-height="200"
                  contain
                  class="grey lighten-2"
                ></v-img>
              </v-col>

              <!-- هشدار اگر جایگزینی -->
              <v-col cols="12" v-if="editingImage">
                <v-alert dense text type="warning" class="text-caption">
                  درصورت ثبت، عکس صفحه {{ editingImage.pageNumber }} جایگزین
                  خواهد شد.
                </v-alert>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeAddImageDialog">انصراف</v-btn>
            <v-btn
              color="primary"
              text
              :disabled="!newImageFile"
              @click="confirmAddImage"
            >
              ثبت
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ====================== Dialog آپلود فایل پین (جدید) ====================== -->
      <v-dialog
        v-if="pinFileDialog"
        v-model="pinFileDialog"
        max-width="450px"
        persistent
      >
        <v-card>
          <v-card-title class="text-h6 IranSans">
            {{ editingPinFile ? "ویرایش فایل" : "بارگذاری فایل" }}
            ({{ pinTypeLabel }})
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  v-model="newPinFile"
                  label="انتخاب فایل"
                  outlined
                  :rules="pinFileRules"
                  persistent-hint
                  @change="onPinFileSelected"
                ></v-file-input>
              </v-col>
              <v-col cols="12" v-if="newPinFileName">
                <div class="d-flex align-center">
                  <v-icon class="mr-2">mdi-file-code</v-icon>
                  <span>{{ newPinFileName }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closePinFileDialog">انصراف</v-btn>
            <v-btn
              color="primary"
              text
              :disabled="!newPinFile"
              @click="confirmPinFile"
            >
              ثبت
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closePage()">بستن</v-btn>
        <v-btn :loading="loading" color="blue darken-1" text @click="submit()">
          ذخیره
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Vue from "vue";
import request from "@/utils/request";
import { hasPermission } from "@/composables/permissions";

export default Vue.extend({
  name: "AddNewDevices",
  props: {
    deviceId: {
      type: [String, Number],
      default: null
    }
  },
  data: () => ({
    valid: false,
    loading: false,
    device: {
      complexId: "",
      name: "",
      hardwareCode: "",
      advertisingCode: "",
      mediaboxUrl: "",
      mediaboxScreenCode: "",
      onlineAdActive: false,
      startTime: "",
      endTime: "",
      lockerCount: 0,
      lightBoxStatusThreshold: 0,
      screenThreshold: 0,
      hasLightBox: false,
      hasScreen: false,
      hasCaseDoor: false,
      hasLoadCell: false,
      pinSync: false,
      termOfUseSync: false,
      uiReplacementSync: false,
      hasIR: false,
      irIsActive: false,
      loadCellIsActive: false,
      hasTelephone: false,
      telephoneActive: false,
      delta: 0,
      multiplier: 1,
      videoEffectPercentage: 0,
      videoPerSeconds: 0,
      impressionMultiplier: 1,
      bias: 0,
      sendSmsStatus: false,
      sendWinGameSmsStatus: false,
      sendLoseGameSmsStatus: false,
      isBranded: false,
      freeSms: false,
      signShow: false,
      powerBoxSign: false,
      smsCredit: "",
      isFullTime: false,
      shouldBeMonitored: true,
      deviceTypeId: null,
      operatorCodeEnabled: false
    },
    deviceConfiguration: {
      games: [],
      gameEnabled: false,
      interactiveMessageEnabled: true,
      chargeContinueEnabled: false,
      safeModeEnabled: false,
      supportedLanguages: ["fa", "en"],
      defaultLanguageCode: "fa",
      supportPhoneNumber: ""
    },
    selectedGameIndex: 0,
    deviceTypes: [],
    languageOptions: [
      { code: "fa", name: "فارسی" },
      { code: "en", name: "انگلیسی" },
      { code: "ar", name: "عربی" }
    ],
    gameOptions: [
      {
        id: 0,
        isActive: false,
        isOnlineGame: false,
        name: "Minesweeper",
        url: null
      },
      {
        id: 1,
        isActive: false,
        isOnlineGame: true,
        name: "Online Game",
        url: null
      }
    ],
    deltaRules: [
      v => !!v || "لطفا مقدار را وارد نمایید",
      v => (v >= 0 && v <= 100) || "مقدار باید بین 0 تا 100 درصد باشد"
    ],
    languageRules: [
      v => (!!v && v.length > 0) || "حداقل یک زبان باید انتخاب شود"
    ],
    defaultLanguageRules: [
      v => (!!v && v !== "") || "انتخاب زبان پیش‌فرض الزامی است"
    ],
    nameRules: [v => !!v || "لطفا نام را وارد نمایید"],
    lockerCountRules: [v => !!v || "لطفا تعداد را وارد نمایید"],
    advertisingCodeRules: [v => !!v || "لطفا کد تبلیغات را وارد نمایید"],
    hardwareCodeRules: [v => !!v || "لطفا نام سخت افزاری را وارد نمایید"],
    urlRules: [
      v =>
        /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(v) ||
        "آدرس URL معتبر نیست"
    ],
    imageFileRules: [v => !!v || "انتخاب عکس الزامی است"],
    pinFileRules: [v => !!v || "انتخاب فایل الزامی است"],

    // مدیریت تصاویر
    termsImages: [],
    uiReplacementImages: [],
    deletedImageIds: [],

    // مدیریت فایل‌های پین (جدید)
    panelPinFile: null,
    adminPinFile: null,
    masterPinFile: null,
    cleanerPinFile: null,

    // Dialog تصاویر
    addImageDialog: false,
    currentImageType: "",
    editingImage: null,
    editingImageArray: null,
    newImageFile: null,
    newImagePageNumber: null,
    newImagePreview: null,

    // Dialog فایل پین (جدید)
    pinFileDialog: false,
    currentPinType: "",
    editingPinFile: null,
    newPinFile: null,
    newPinFileName: ""
  }),

  computed: {
    hasActiveGame() {
      return this.deviceConfiguration.games.some(g => g.isActive === true);
    },
    gameSelectionErrorMessage() {
      if (!this.deviceConfiguration.gameEnabled) return "";
      if (!this.hasActiveGame) {
        return "حداقل یک بازی باید انتخاب شود";
      }
      return "";
    },
    pinTypeLabel() {
      const labels = {
        PanelPin: "پنل پین",
        AdminPin: "ادمین پین",
        MasterPin: "مستر پین",
        CleanerPin: "کلینر پین"
      };
      return labels[this.currentPinType] || "";
    }
  },

  created() {
    this.device.complexId = this.$route.params.id;
    if (this.deviceTypePerm()) this.fetchDeviceTypes();

    if (this.deviceId) {
      this.getDevice(this.deviceId);
    } else {
      this.resetForm();
    }
  },

  watch: {
    deviceId(newId) {
      if (newId) {
        this.getDevice(newId);
      } else {
        this.resetForm();
      }
    },
    "device.hasLoadCell"(newVal) {
      if (!newVal) {
        this.device.loadCellIsActive = false;
      }
    },
    "device.hasIR"(newVal) {
      if (!newVal) {
        this.device.irIsActive = false;
      }
    },
    "device.hasTelephone"(newVal) {
      if (!newVal) {
        this.device.telephoneActive = false;
      }
    }
  },

  methods: {
    deviceTypePerm() {
      return hasPermission("DeviceType_View");
    },
    async fetchDeviceTypes() {
      const response = await request.get("/device/devicetype");
      this.deviceTypes = response.data.result;
    },

    async getDevice(id) {
      const response = await request.get(`/device/${id}`);
      const data = response.data.result;

      this.device = {
        ...this.device,
        name: data.name,
        hardwareCode: data.hardwareCode,
        advertisingCode: data.advertisingCode,
        mediaboxUrl: data.mediaboxUrl,
        mediaboxScreenCode: data.mediaboxScreenCode,
        onlineAdActive: data.onlineAdActive,
        startTime: data.startTime,
        endTime: data.endTime,
        lockerCount: data.lockerCount,
        active: data.active,
        lightBoxStatusThreshold: data.lightBoxStatusThreshold,
        screenThreshold: data.screenThreshold,
        hasLightBox: data.hasLightBox,
        pinSync: data.pinSync,
        termOfUseSync: data.termOfUseSync,
        uiReplacementSync: data.uiReplacementSync,
        hasScreen: data.hasScreen,
        hasCaseDoor: data.hasCaseDoor,
        hasLoadCell: data.hasLoadCell,
        hasIR: data.hasIR,
        irIsActive: data.irIsActive,
        loadCellIsActive: data.loadCellIsActive,
        hasTelephone: data.hasTelephone,
        telephoneActive: data.telephoneActive,
        delta: data.delta,
        videoPerSeconds: data.videoPerSeconds,
        videoEffectPercentage: data.videoEffectPercentage,
        multiplier: data.multiplier,
        impressionMultiplier: data.impressionMultiplier,
        bias: data.bias,
        sendSmsStatus: data.sendSmsStatus,
        sendWinGameSmsStatus: data.sendWinGameSmsStatus,
        sendLoseGameSmsStatus: data.sendLoseGameSmsStatus,
        isBranded: data.isBranded,
        deviceTypeId: data.deviceTypeId,
        shouldBeMonitored: data.shouldBeMonitored,
        freeSms: data.freeSms,
        signShow: data.signShow,
        powerBoxSign: data.powerBoxSign,
        smsCredit: data.smsCredit,
        isFullTime: data.isFullTime,
        operatorCodeEnabled: data.operatorCodeEnabled || false
      };

      if (data.configuration) {
        this.deviceConfiguration = {
          games: data.configuration.games || [],
          gameEnabled: data.configuration.gameEnabled || false,
          interactiveMessageEnabled:
            data.configuration.interactiveMessageEnabled || false,
          chargeContinueEnabled:
            data.configuration.chargeContinueEnabled || false,
          safeModeEnabled: data.configuration.safeModeEnabled || false,
          supportedLanguages: data.configuration.supportedLanguages || [],
          defaultLanguageCode: data.configuration.defaultLanguageCode || "",
          supportPhoneNumber: data.configuration.supportPhoneNumber || ""
        };
        if (data.configuration.games && data.configuration.games.length > 0) {
          data.configuration.games.forEach(receivedGame => {
            if (this.gameOptions[receivedGame.id]) {
              this.gameOptions[receivedGame.id].id = receivedGame.id;
              this.gameOptions[receivedGame.id].isActive =
                receivedGame.isActive;
              this.gameOptions[receivedGame.id].url = receivedGame.url;
            }
          });
        }
        this.updateSelectedGameIndex();
      }

      await this.loadDeviceImages(id);
    },

    async loadDeviceImages(deviceId) {
      try {
        const response = await request.get(`/device/images/${deviceId}`);
        const images = response.data.result || [];

        this.termsImages = [];
        this.uiReplacementImages = [];
        this.panelPinFile = null;
        this.adminPinFile = null;
        this.masterPinFile = null;
        this.cleanerPinFile = null;

        images.forEach(img => {
          const imageObj = {
            id: img.id,
            pageNumber: img.pageNumber || 0,
            previewUrl: img.downloadPath,
            filePath: img.filePath,
            originalFileName: img.originalFileName,
            isExisting: true,
            file: null
          };

          if (img.type === 1 || img.type === "TermsAndConditions") {
            this.termsImages.push(imageObj);
          } else if (img.type === 2 || img.type === "UIReplacement") {
            this.uiReplacementImages.push(imageObj);
          } else if (img.type === 3 || img.type === "PanelPin") {
            this.panelPinFile = imageObj;
          } else if (img.type === 4 || img.type === "AdminPin") {
            this.adminPinFile = imageObj;
          } else if (img.type === 5 || img.type === "MasterPin") {
            this.masterPinFile = imageObj;
          } else if (img.type === 6 || img.type === "CleanerPin") {
            this.cleanerPinFile = imageObj;
          }
        });

        this.renumberImages("TermsAndConditions");
      } catch (error) {
        console.error("Error loading device images:", error);
      }
    },

    resetForm() {
      this.device = {
        complexId: this.$route.params.id,
        name: "",
        hardwareCode: "",
        advertisingCode: "",
        startTime: "",
        mediaboxUrl: "",
        mediaboxScreenCode: "",
        onlineAdActive: false,
        lightBoxStatusThreshold: 0,
        screenThreshold: 0,
        hasLightBox: false,
        pinSync: false,
        termOfUseSync: false,
        uiReplacementSync: false,
        hasScreen: false,
        hasCaseDoor: false,
        loadCellIsActive: false,
        hasLoadCell: false,
        hasIR: false,
        irIsActive: false,
        hasTelephone: false,
        telephoneActive: false,
        delta: 0,
        multiplier: 1,
        videoEffectPercentage: 0,
        videoPerSeconds: 0,
        impressionMultiplier: 1,
        bias: 0,
        endTime: "",
        lockerCount: 0,
        sendSmsStatus: false,
        sendWinGameSmsStatus: false,
        sendLoseGameSmsStatus: false,
        isBranded: false,
        shouldBeMonitored: true,
        freeSms: false,
        signShow: false,
        powerBoxSign: false,
        smsCredit: "",
        isFullTime: false,
        deviceTypeId: null,
        operatorCodeEnabled: false
      };
      this.deviceConfiguration = {
        games: [],
        interactiveMessageEnabled: false,
        chargeContinueEnabled: false,
        safeModeEnabled: false,
        supportedLanguages: [],
        defaultLanguageCode: "",
        supportPhoneNumber: ""
      };
      this.selectedGameIndex = null;
      this.termsImages = [];
      this.uiReplacementImages = [];
      this.deletedImageIds = [];
      this.panelPinFile = null;
      this.adminPinFile = null;
      this.masterPinFile = null;
      this.cleanerPinFile = null;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    closePage() {
      if (this.$router) {
        this.$router.go(-1);
      }
      this.$emit("close");
    },

    removeLanguage(langCode) {
      this.deviceConfiguration.supportedLanguages = this.deviceConfiguration.supportedLanguages.filter(
        l => l !== langCode
      );
      if (this.deviceConfiguration.defaultLanguageCode === langCode) {
        this.deviceConfiguration.defaultLanguageCode =
          this.deviceConfiguration.supportedLanguages[0] || "";
      }
    },

    getLanguageName(langCode) {
      const lang = this.languageOptions.find(l => l.code === langCode);
      return lang ? lang.name : langCode;
    },

    getLanguageOptions() {
      return this.languageOptions.filter(i =>
        this.deviceConfiguration.supportedLanguages.includes(i.code)
      );
    },

    updateSelectedGameIndex() {
      const activeIndex = this.gameOptions.findIndex(g => g.isActive === true);
      this.selectedGameIndex = activeIndex !== -1 ? activeIndex : 0;
    },

    onGameSelectionChange(index) {
      if (index != null && index != undefined)
        this.gameOptions.forEach((game, i) => {
          game.isActive = i === index;
        });
    },

    // ----- مدیریت تصاویر (شماره‌گذاری، دیالوگ) -----
    renumberImages(type) {
      const array =
        type === "TermsAndConditions"
          ? this.termsImages
          : this.uiReplacementImages;
      array.forEach((img, idx) => {
        img.pageNumber = idx + 1;
      });
    },

    openAddImageDialog(type) {
      this.currentImageType = type;
      this.editingImage = null;
      this.editingImageArray = null;
      this.newImageFile = null;
      this.newImagePreview = null;

      const array =
        type === "TermsAndConditions"
          ? this.termsImages
          : this.uiReplacementImages;
      const maxPage =
        array.length > 0 ? Math.max(...array.map(img => img.pageNumber)) : 0;
      this.newImagePageNumber = maxPage + 1;

      this.addImageDialog = true;
    },

    editImage(type, index) {
      const array =
        type === "TermsAndConditions"
          ? this.termsImages
          : this.uiReplacementImages;
      const img = array[index];
      if (!img) return;

      this.currentImageType = type;
      this.editingImage = img;
      this.editingImageArray = array;
      this.newImageFile = null;
      this.newImagePreview = null;
      this.newImagePageNumber = img.pageNumber;
      this.addImageDialog = true;
    },

    closeAddImageDialog() {
      if (this.newImagePreview) {
        URL.revokeObjectURL(this.newImagePreview);
      }
      this.addImageDialog = false;
      this.editingImage = null;
      this.editingImageArray = null;
      this.newImageFile = null;
      this.newImagePageNumber = null;
      this.newImagePreview = null;
    },

    onNewImageSelected(file) {
      if (this.newImagePreview) {
        URL.revokeObjectURL(this.newImagePreview);
      }
      this.newImagePreview = file ? URL.createObjectURL(file) : null;
    },

    confirmAddImage() {
      if (!this.newImageFile) return;

      const newImg = {
        id: null,
        pageNumber: this.newImagePageNumber,
        previewUrl: this.newImagePreview,
        isExisting: false,
        file: this.newImageFile
      };

      const targetArray =
        this.currentImageType === "TermsAndConditions"
          ? this.termsImages
          : this.uiReplacementImages;

      if (this.editingImage) {
        const oldImg = this.editingImage;
        if (oldImg.isExisting && oldImg.id) {
          this.deletedImageIds.push(oldImg.id);
        } else if (!oldImg.isExisting && oldImg.previewUrl) {
          URL.revokeObjectURL(oldImg.previewUrl);
        }
        const idx = targetArray.indexOf(oldImg);
        if (idx !== -1) {
          targetArray.splice(idx, 1, newImg);
        }
      } else {
        targetArray.push(newImg);
      }
      if (this.currentImageType === "TermsAndConditions")
        this.renumberImages(this.currentImageType);

      this.newImagePreview = null;
      this.addImageDialog = false;
      this.editingImage = null;
      this.editingImageArray = null;
      this.newImageFile = null;
      this.newImagePageNumber = null;
    },

    removeTermsImage(index) {
      const img = this.termsImages[index];
      if (img.isExisting && img.id) {
        this.deletedImageIds.push(img.id);
      } else if (!img.isExisting && img.previewUrl) {
        URL.revokeObjectURL(img.previewUrl);
      }
      this.termsImages.splice(index, 1);
      this.renumberImages("TermsAndConditions");
    },

    removeUiReplacementImage(index) {
      const img = this.uiReplacementImages[index];
      if (img.isExisting && img.id) {
        this.deletedImageIds.push(img.id);
      } else if (!img.isExisting && img.previewUrl) {
        URL.revokeObjectURL(img.previewUrl);
      }
      this.uiReplacementImages.splice(index, 1);
    },

    openPinFileDialog(type) {
      this.currentPinType = type;
      this.editingPinFile = this.getPinFileObject(type);
      this.newPinFile = null;
      this.newPinFileName = "";
      this.pinFileDialog = true;
    },

    getPinFileObject(type) {
      const map = {
        PanelPin: this.panelPinFile,
        AdminPin: this.adminPinFile,
        MasterPin: this.masterPinFile,
        CleanerPin: this.cleanerPinFile
      };
      return map[type] || null;
    },

    setPinFileObject(type, fileObj) {
      if (type === "PanelPin") this.panelPinFile = fileObj;
      else if (type === "AdminPin") this.adminPinFile = fileObj;
      else if (type === "MasterPin") this.masterPinFile = fileObj;
      else if (type === "CleanerPin") this.cleanerPinFile = fileObj;
    },

    onPinFileSelected(file) {
      this.newPinFileName = file ? file.name : "";
    },

    closePinFileDialog() {
      this.pinFileDialog = false;
      this.editingPinFile = null;
      this.newPinFile = null;
      this.newPinFileName = "";
    },

    confirmPinFile() {
      if (!this.newPinFile) return;

      const newFileObj = {
        id: null,
        pageNumber: 1,
        downloadPath: null,
        originalFileName: this.newPinFile.name,
        isExisting: false,
        file: this.newPinFile
      };

      if (
        this.editingPinFile &&
        this.editingPinFile.isExisting &&
        this.editingPinFile.id
      ) {
        this.deletedImageIds.push(this.editingPinFile.id);
      }

      this.setPinFileObject(this.currentPinType, newFileObj);
      this.closePinFileDialog();
    },

    removePinFile(type) {
      const fileObj = this.getPinFileObject(type);
      if (fileObj) {
        if (fileObj.isExisting && fileObj.id) {
          this.deletedImageIds.push(fileObj.id);
        }
        this.setPinFileObject(type, null);
      }
    },

    downloadPinFile(type) {
      const fileObj = this.getPinFileObject(type);
      if (fileObj && fileObj.id) {
        request
          .get(`/device/device-file/${Number.parseInt(fileObj.id)}`, {
            responseType: "blob"
          })
          .then(response => {
            if (!response.data || response.data.size === 0) {
              alert("دیتایی برای دانلود یافت نشد");
              return;
            }

            // از همان Blob که از سرور آمده استفاده کن
            const blob = response.data; // نیازی به new Blob نیست

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileObj.originalFileName;
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          })
          .catch(() => {
            alert("خطا در دریافت فایل");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    ViewImage(previewUrl) {
      if (previewUrl) {
        window.open(previewUrl, "_blank");
      }
    },

    // ----- ثبت نهایی -----
    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;

      try {
        const submitData = {
          ...this.device,
          configuration: {
            gameEnabled: this.deviceConfiguration.gameEnabled,
            games: !this.deviceConfiguration.gameEnabled
              ? []
              : this.gameOptions.filter(i => i.isActive === true) ?? [],
            interactiveMessageEnabled: this.deviceConfiguration
              .interactiveMessageEnabled,
            chargeContinueEnabled: this.deviceConfiguration
              .chargeContinueEnabled,
            safeModeEnabled: this.deviceConfiguration.safeModeEnabled,
            supportedLanguages: this.deviceConfiguration.supportedLanguages,
            defaultLanguageCode: this.deviceConfiguration.defaultLanguageCode,
            supportPhoneNumber: this.deviceConfiguration.supportPhoneNumber
          }
        };

        let savedDeviceId = this.deviceId;

        if (this.deviceId) {
          await request.put(`/device/${this.deviceId}`, submitData);
        } else {
          const response = await request.post("/device", submitData);
          savedDeviceId = response.data?.result?.id || response.data?.id;
        }

        if (this.deletedImageIds.length > 0) {
          const queryString = this.deletedImageIds
            .map(id => `ids=${id}`)
            .join("&");
          await request.delete(`/device/images?${queryString}`);
        }

        const uploadNewImages = async (images, typeValue) => {
          const newImages = images.filter(img => !img.isExisting && img.file);
          if (newImages.length === 0) return;

          const formData = new FormData();
          newImages.forEach((img, index) => {
            formData.append("files", img.file);
            formData.append(`pageNumbers[${index}]`, img.pageNumber);
          });

          await request.post(
            `/device/images/${savedDeviceId}?type=${typeValue}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }
          );
        };

        await uploadNewImages(this.termsImages, 1);
        await uploadNewImages(this.uiReplacementImages, 2);

        const uploadSinglePin = async (fileObj, typeValue) => {
          if (fileObj && !fileObj.isExisting && fileObj.file) {
            const formData = new FormData();
            formData.append("files", fileObj.file);
            formData.append("pageNumbers[0]", 1);

            await request.post(
              `/device/images/${savedDeviceId}?type=${typeValue}`,
              formData,
              {
                headers: { "Content-Type": "multipart/form-data" }
              }
            );
          }
        };

        await uploadSinglePin(this.panelPinFile, 3);
        await uploadSinglePin(this.adminPinFile, 4);
        await uploadSinglePin(this.masterPinFile, 5);
        await uploadSinglePin(this.cleanerPinFile, 6);

        this.$emit("reloadDevices");
        this.closePage();
      } catch (error) {
        console.error("Error saving device:", error);
      } finally {
        this.loading = false;
      }
    }
  }
});
</script>

<style scoped>
::v-deep .container {
  padding: 0 !important;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

.card-form-img {
  padding: 0px !important;
}

.icon-btn-modal {
  position: absolute;
  font-size: 18px !important;
  color: #fff !important;
  padding: 8px;
  border-radius: 50%;
}

.icon-btn-modal:hover {
  cursor: pointer;
}

::v-deep .v-input--selection-controls {
  margin-top: 0 !important;
}

::v-deep .v-select__slot .v-select__selections {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.icon-btn-upload {
  position: absolute;
  left: 60%;
  bottom: 33%;
  color: #fff !important;
  border-radius: 50%;
  text-align: center;
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: center;
}

.logo-title {
  text-align: center;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.IranSans {
  font-family: "IranSans", sans-serif !important;
}
</style>
